module.exports = __webpack_public_path__ + "static/media/10.b744e7f5.svg";